export const UNALLOCATE_PAYMENT = gql`
    mutation UnallocatePayment($input: UnallocatePaymentInput) {
        unallocatePayment(input: $input) {
            message
        }
    }
`;
